import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import HighSchoolPreviewBanner from 'components/HighSchoolPreviewBanner'
import SiteSelector from 'components/SiteSelector'
import {
  BannerSpacer,
  PageContainer,
  LayoutContainer,
  ColumnContainer,
  RowContainer,
  SectionContainer,
  SiteSelectorWrapper,
} from './component.styles'
import {
  HIGH_SCHOOL_INDIVIDUAL_RESOURCE_PATH,
  filterByResourceType,
} from 'utils/highschoolHelpers'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContextLegacy'
import { CardSection } from './cardSection'
import {
  educatorHeader,
  educatorTooltipLabel,
  schoolwideHeader,
  schoolwideTooltipLabel,
  studentTooltipLabel,
} from './constants'

function shouldShowDedicatedResources(dedicatedResources) {
  return !!dedicatedResources && dedicatedResources.length > 0
}

const Week = props => {
  const [displayTitle, setDisplayTitle] = useState()
  const [description, setDescription] = useState()
  const [dedicatedResources, setDedicatedResources] = useState()
  const [dedicatedLabel, setDedicatedLabel] = useState()
  const [integrated, setIntegrated] = useState({
    educatorResources: [],
    schoolwideResources: [],
  })
  const [educatorDescription, setEducatorDescription] = useState()
  const [schoolwideDescription, setSchoolwideDescription] = useState()
  const [activitiesDescription, setActivitiesDescription] = useState()

  const [tooltips, setTooltips] = useState([])

  const { content, navigationEvent, isPreview } = props

  useEffect(() => {
    if (!content) {
      return
    }

    const { week } = content

    if (week) {
      if (week.displayTitle) setDisplayTitle(week?.displayTitle)
      if (week.description) setDescription(week?.description)
      if (week.dedicatedResources)
        setDedicatedResources(week.dedicatedResources)
      if (week.dedicatedLabel) setDedicatedLabel(week.dedicatedLabel)
      if (week.integrated) {
        const educatorResources = filterByResourceType(
          week.integrated,
          educatorHeader,
        )
        const schoolwideResources = filterByResourceType(
          week.integrated,
          schoolwideHeader,
        )
        setIntegrated({ educatorResources, schoolwideResources })
      }
      if (week.educatorDescription) {
        setEducatorDescription(week?.educatorDescription)
      }
      if (week.schoolwideDescription) {
        setSchoolwideDescription(week?.schoolwideDescription)
      }
      if (week.activitiesDescription) {
        setActivitiesDescription(week?.activitiesDescription)
      }
      if (week.tooltips) setTooltips(week.tooltips)
    }
  }, [content])

  const extractResourceType = resources => {
    return resources.map(resource => {
      const resourceType = resource.metadataValues.map(
        metadata => metadata.resourceType,
      )
      return { ...resource, resourceType }
    })
  }

  const onClick = routeSlug => {
    const { search: searchParams } = location
    navigationEvent(
      `${HIGH_SCHOOL_INDIVIDUAL_RESOURCE_PATH}/${routeSlug}${searchParams}`,
    )
  }

  return (
    <>
      {isPreview && (
        <>
          <BannerSpacer />
          <HighSchoolPreviewBanner />
        </>
      )}
      <LayoutContainer>
        <PageContainer>
          {!isPreview && (
            <SiteSelectorWrapper>
              <SiteSelector />
            </SiteSelectorWrapper>
          )}
          <ColumnContainer>
            <h1>{displayTitle}</h1>
            <p className="description">{description}</p>
            <RowContainer>
              <SectionContainer>
                {integrated?.schoolwideResources?.length > 0 && (
                  <CardSection
                    description={schoolwideDescription}
                    headerText={schoolwideHeader}
                    isSingleCard={integrated?.schoolwideResources?.length === 1}
                    isWideCards={integrated?.schoolwideResources?.length > 1}
                    onClick={onClick}
                    recourceType={extractResourceType(
                      integrated?.schoolwideResources,
                    )}
                    resources={integrated?.schoolwideResources}
                    tooltipLabel={schoolwideTooltipLabel}
                    tooltips={tooltips}
                  />
                )}
              </SectionContainer>
            </RowContainer>
            <RowContainer
              isSingleCard={integrated?.educatorResources?.length === 1}
            >
              <SectionContainer>
                {integrated?.educatorResources?.length > 0 && (
                  <CardSection
                    description={educatorDescription}
                    headerText={educatorHeader}
                    isSingleCard={integrated?.educatorResources?.length === 1}
                    isWideCards={integrated?.educatorResources?.length > 1}
                    onClick={onClick}
                    recourceType={extractResourceType(
                      integrated?.educatorResources,
                    )}
                    resources={integrated?.educatorResources}
                    tooltipLabel={educatorTooltipLabel}
                    tooltips={tooltips}
                  />
                )}
              </SectionContainer>
            </RowContainer>
          </ColumnContainer>
          {shouldShowDedicatedResources(dedicatedResources) && (
            <CardSection
              description={activitiesDescription}
              headerText={dedicatedLabel}
              isSingleCard={dedicatedResources?.length === 1}
              onClick={onClick}
              recourceType={extractResourceType(dedicatedResources)}
              resources={dedicatedResources}
              tooltipLabel={studentTooltipLabel}
              tooltips={tooltips}
            />
          )}
        </PageContainer>
      </LayoutContainer>
    </>
  )
}

Week.propTypes = {
  content: PropTypes.shape({
    week: PropTypes.shape({
      displayTitle: PropTypes.string.isRequired,
      dedicatedLabel: PropTypes.string,
      tooltips: PropTypes.array,
      description: PropTypes.string.isRequired,
      integrated: PropTypes.array,
      dedicatedResources: PropTypes.array,
      educatorDescription: PropTypes.string,
      schoolwideDescription: PropTypes.string,
      activitiesDescription: PropTypes.string,
    }),
  }),
  isFetching: PropTypes.bool,
  isPreview: PropTypes.bool,
  isSingleCard: PropTypes.bool,
  navigationEvent: PropTypes.func,
}

export default withSiteContext(Week, {
  useGuard: true,
})
